import {Component, OnDestroy, OnInit} from '@angular/core';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {LoginService} from '../../shared-modules/login/login.service';

@AutoUnsubscribe()
@Component({
  selector: 'student-documents',
  templateUrl: './student-documents.component.html',
  styles: []
})
export class StudentDocumentsComponent implements OnInit, OnDestroy {

  isV10: boolean;

  constructor(private loginService: LoginService) {
    this.isV10 = this.loginService.LoginSettings.V10;
  }

  ngOnInit(): void {
   // initialize stuff
  }

  ngOnDestroy(): void {
    // destroy stuff
  }

}
